import React from 'react';

const CardActiveUsers = ({ title, value, onClick }) => {
  return (
    <div 
      onClick={onClick}
      className="max-w-[95vw] md:max-w-[800px] mx-auto my-4 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center justify-center p-2 cursor-pointer"
      style={{ minHeight: '50px', maxHeight:'58px' }} // Slightly taller than 50px to fit text & animation
    >
      <div className="flex items-center flex-col text-white mr-4">
        <span className="font-medium text-[#2ecc71]">{title}</span>
        {value && <span className="text-sm font-semibold">{value}</span>}
      </div>
    </div>
  );
};

export default CardActiveUsers;